export default __webpack_public_path__ + "static/media/admin-bg4.a5912c21.jpg";